import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '@core/services/auth.service';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkDirective } from '@shared/directives/router-link.directive';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-retrieve-username',
  templateUrl: './retrieve-username.component.html',
  styleUrls: ['./retrieve-username.component.scss'],
  imports: [TranslateModule, FormsModule, CommonModule, RouterLinkDirective, LocalizeRouterModule]
})
export class RetrieveUsernameComponent {

  private _destroy$ = new Subject<any>();
  email: string;
  message: string

  constructor( private authService: AuthService) { }


  sendRequest(form){
    this.authService.getUserName(this.email).pipe(
      takeUntil(this._destroy$),
    ).subscribe(
      () => this.onComplete(form),
      () => this.onComplete(form),
    );
  }

  private onComplete(form): void {
    this.email = null;
    this.message = 'Your username has been send to your email';
    form.resetForm();
  }

}
